import { render, staticRenderFns } from "./CaseManagement.vue?vue&type=template&id=ac210056&scoped=true"
import script from "./CaseManagement.vue?vue&type=script&lang=ts"
export * from "./CaseManagement.vue?vue&type=script&lang=ts"
import style0 from "./CaseManagement.vue?vue&type=style&index=0&id=ac210056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac210056",
  null
  
)

export default component.exports